<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-23 21:15:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/Swiper/index.vue
-->
<template>
  <div>
    <van-swipe indicator-color="#fff" ref="swipe" class="index_swiper">
      <van-swipe-item v-for="(image, index) in pictures" :key="index">
        <img v-lazy="image.masterImg" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
export default {
  props: {
    pictures: {
      type: Array,
      default() {
        return [];
      }
    },
    chooseSkuIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // images: [
      //   require("@/assets/mooc/banner@2x.png"),
      //   require("@/assets/mooc/banner@2x.png"),
      //   require("@/assets/mooc/banner@2x.png"),
      //   require("@/assets/mooc/banner@2x.png")
      // ]
    };
  },
  watch: {
    chooseSkuIndex() {
      this.$refs.swipe.swipeTo(this.chooseSkuIndex);
    }
  }
};
</script>
<style scoped>
.index_swiper {
  text-align: center;
  max-height: 375px;
  margin-bottom: 12px;
}
.index_swiper img {
  width: 100%;
}
.index_swiper >>> .van-swipe__indicator {
  width: 16px;
  height: 3px;
  background: #fff;
  border-radius: 2px;
  margin: 0 0 12px 0;
}
</style>
